import React, { useState } from 'react';
import { Box } from '@mui/material';

import { Card } from 'components/TeamOverview/components/Common/Card/Card';
import { CardHeader } from 'components/UserProfile/components/CardHeader';
import { HeaderTabs } from 'components/UserProfile/components/HeaderTabs';
import { LatestCommentsCard } from 'components/UserProfile/LatestCommentsCard/LatestCommentsCard';
import { AnnotationsCard } from 'components/UserProfile/AnnotationsCard/AnnotationsCard';

import {
  LATEST_COMMENTS_TAB_VALUE,
  TEAM_COMMUNICATION_TABS_LIST,
} from 'components/UserProfile/constants';

import { useOrdersTabContentStyles } from 'components/UserProfile/styles';

export const TeamCommunication = ({ newsFeed, onLoadMore, isLoadingMore }) => {
  const { classes } = useOrdersTabContentStyles();

  const [currentTabValue, setCurrentTabValue] = useState(
    LATEST_COMMENTS_TAB_VALUE,
  );

  return (
    <Card
      header={
        <Box padding="1.125rem">
          <CardHeader
            title="TEAM COMMUNICATION"
            subtitle=""
            RightSection={
              <HeaderTabs
                currentTabValue={currentTabValue}
                handleTabChange={(_, tabValue) => setCurrentTabValue(tabValue)}
                tabsList={TEAM_COMMUNICATION_TABS_LIST}
              />
            }
          />
        </Box>
      }
    >
      {currentTabValue === LATEST_COMMENTS_TAB_VALUE ? (
        <Box className={classes.ordersList}>
          <LatestCommentsCard
            newsFeed={newsFeed}
            onLoadMore={onLoadMore}
            isLoadingMore={isLoadingMore}
          />
        </Box>
      ) : (
        <AnnotationsCard />
      )}
    </Card>
  );
};
